export default __webpack_public_path__ + "static/seo-potato-b91c3929f8a21b137a682f38336b0fb3.png";